import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { MechanismSection } from '../components/MechanismSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { IncludesSection } from '../components/IncludesSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { TransformationSection } from '../components/TransformationSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="min-h-screen bg-navy-900 text-cream-50 selection:bg-gold-500/30 selection:text-gold-200" data-id="element-216">
      <Hero data-id="element-217" />
      <ProblemSection data-id="element-218" />
      <SolutionSection data-id="element-219" />
      <MechanismSection data-id="element-220" />
      <BenefitsSection data-id="element-221" />
      <IncludesSection data-id="element-222" />
      <ForWhoSection data-id="element-223" />
      <TransformationSection data-id="element-224" />
      <CTASection data-id="element-225" />
      <Footer data-id="element-226" />
    </main>;
}